export const ROUTING_SET_SELECTED_URL = 'ROUTING_SET_SELECTED_URL';
export const ROUTING_SET_PAGE_DATA = 'ROUTING_SET_PAGE_DATA';
